<div id="sandhub-workarea">
  <div class="title-bar-area-search">
    <div class="title-area-search">{{title}}</div>
    <!-- <div class="video-icon" (click)="openPopup()"><i class="far fa-video"></i></div> -->
    <app-video-modal *ngIf="showPopup==true" [videoUrl]="videoDetail" (closeVideoPopup)="closeVideoPopup($event)"></app-video-modal>
  </div>
</div>
<div class="search-container">
  <div class="search-box">
    <input id="txtSearch" type="text" class="search-text" autofocus="autofocus" (keyup.enter)="runSearch()" />
    <button class="search-button" title="Search" (click)="runSearch()">
      <span class="far fa-search"></span>
    </button>
    <button class="clearbtn" title="Clear" (click)="clearSearch()">
      Clear
    </button>
    <!--<div class="search-results-elapsed" *ngIf="searchResult && pageCollectionCount!=0">Showing {{itemFrom}} to {{itemTo}} of approximately {{searchResult?.estimatedCount}} results. ({{searchResult?.elapsedTime|numberFormat:"ms2s":1}} seconds)</div>-->
    <div class="search-results-elapsed">Showing {{itemFrom}} to {{itemTo}} of approximately {{searchResult?.estimatedCount}} results. ({{searchResult?.elapsedTime|numberFormat:"ms2s":1}} seconds)</div>
  </div>
  <div class="search-results">
    <div class="search-results-container">
      <app-search-item *ngFor="let result of searchResult?.results" [item]="result"></app-search-item>
    </div>
  </div>
  <div class="d-flex search-pager justify-content-center" *ngIf="searchResult">
    <ngb-pagination [(page)]="searchResult.pageNumber"
                    [pageSize]="searchResult.pageSize"
                    [collectionSize]="pageCollectionCount"
                    [maxSize]="10"
                    (pageChange)="loadPage($event)"></ngb-pagination>
  </div>
  <div class="search-filter"><app-search-facets [facets]="searchResult?.facets" (filter)="filterClick($event)" [selectedDocument]="selectedDocument"></app-search-facets></div>
  <div class="search-topsearches">
    <app-search-saved (runSavedQuery)="runSavedQuery($event)"></app-search-saved>
    <app-search-company (simpleSearch)="simpleSearch($event)"></app-search-company>

  </div>
  <app-busy [show]="showBusy"></app-busy>
  <div class="search-spinner" style="display: none; z-index: 1000;">
    <i class="fa fa-circle-o-notch fa-spin spinner" id="spinner" aria-hidden="true"></i>
  </div>
</div>
